module.exports = __webpack_public_path__ + "static/media/cloud-snow.54323704.svg";